"use strict";
import { Type, Runtime, Dom } from "main.core";
import { VSCore } from "vsbx.core";
let cacheSearchItem = {},
  timeDuration,
  duration = 1000;
export class Search {
  constructor(options) {
    let self = this;
    self.name = "Search";
    self.options = options;
    if (options.duration) {
      duration = options.duration;
    }
    self.container = options.id
      ? document.querySelector("#" + options.id)
      : null;
    if (self.container) {
      Runtime.loadExtension("vsbx.vsdefaultdataprovider").then((exports) => {
        const { DefaultDataProvider } = exports;
        self.dataProvider = new DefaultDataProvider(
          self.container,
          options.configController
        );
        self.dataProvider.start = () => {};
        self.dataProvider.done = () => {};
      });
      self.inputSearch = self.container.querySelector("input");
      let q = VSCore.utilURL.getUrlQueryString("q");
      if (q !== "") {
        self.inputSearch.value = q;
      }
      self.inputSearch.addEventListener(
        "input",
        BX.delegate(self.getSearch, self)
      );
      if (options.url_search) {
        self.inputSearch.addEventListener(
          "keydown",
          BX.delegate(function (e) {
            if (e.code === "Enter") {
              self.runSearch();
            }
          }, self)
        );
      }

      self.btnSubmit = self.container.querySelector(".search-title-button");
      self.btnSubmit.addEventListener(
        "click",
        BX.delegate(self.runSearch, self)
      );
      self.btnSection = self.container.querySelector(".btn-section");
      if (self.btnSection)
        self.btnSectionMenu =
          self.container.querySelectorAll(".dropdown-menu a");
      Runtime.loadExtension("main.popup").then((exports) => {
        const { PopupMenu, PopupMenuWindow, PopupWindowButton, PopupWindow } =
          exports;
        let modalParams = {
          //titleBar: 'rwerwer',
          width: BX.width(self.container), // ширина окна
          //height: 600, // высота окна
          zIndex: 10000, // z-index
          closeIcon: {
            opacity: 1,
          },
          closeByEsc: true, // закрытие окна по esc
          autoHide: true, // закрытие при клике вне окна
          draggable: false, // можно двигать или нет
          min_height: 60, // минимальная высота окна
          min_width: 100, // минимальная ширина окна
          lightShadow: false, // использовать светлую тень у окна
          //angle: true, // появится уголок
          resizable: false, // можно ресайзить
          offsetLeft: 12,
          offsetTop: 3,
          drag_restrict: false,
          resize_restrict: false,
          // overlay: {
          //   backgroundColor: "black",
          //   opacity: 500,
          // },
          events: {
            onPopupClose: function () {},
            onPopupShow: function () {},
          },
        };
        self.popup = new BX.PopupWindow(
          "popup_" + options.id.replace("#", ""),
          self.inputSearch,
          modalParams
        );
        BX.addClass(self.popup.popupContainer, "row row-cols-1 pop-search");
      });
      if (self.btnSectionMenu) {
        let setActive = function () {
          self.btnSectionMenu.forEach((el) => {
            BX.removeClass(el, "active");
          });
        };
        self.btnSectionMenu.forEach((el) => {
          el.addEventListener("click", (e) => {
            setActive();
            self.btnSection.innerHTML = el.innerText;
            self.currentSection = el.dataset.id;
            BX.addClass(el, "active");
          });
        });
      }
    }
  }
  runSearch() {
    if (this.inputSearch.value.length > 1) {
      let url = this.options.url_search;
      url = url + "?q=" + this.inputSearch.value;
      if (this.currentSection) {
        url = url + "&SECTION_ID=" + this.currentSection;
      }
      location.href = url;
    }
  }
  getSearch() {
    let self = this;

    if (self.inputSearch.value.length > 1) {
      let keyCache = self.inputSearch.value;
      if (self.currentSection) {
        keyCache = keyCache + "_" + self.currentSection;
      }
      if (cacheSearchItem[keyCache]) {
        self.setResult(cacheSearchItem[keyCache]);
      } else {
        clearTimeout(timeDuration);
        timeDuration = setTimeout(() => {
          let data = {
            q: self.inputSearch.value,
          };
          if (self.currentSection) {
            data.SECTION_ID = self.currentSection;
          }
          self.dataProvider.run("get", data, (d) => {
            cacheSearchItem[keyCache] = d.data;
            self.setResult(d.data);
          });
        }, duration);
      }
    }
  }
  setResult(data) {
    let self = this;
    self.currentData = data;
    if (
      self.currentData &&
      self.currentData.items &&
      self.currentData.items.length
    ) {
      BX.cleanNode(self.popup.popupContainer);
      let div;
      self.currentData.items.forEach((item) => {
        let t = "";
        if (item.img) {
          t =
            '<div class="search-img" style="background-image: url(\'' +
            item.img +
            "')\"></div>";
        } else {
          t = '<div class="search-img"></div>';
        }
        t +=
          '<div class="search-info"><a href="' +
          item.url +
          '" class="link"><div class="search-info-name">' +
          item.name +
          '</div><div class="search-info-text">' +
          item.SECTION_NAME +
          "</div></a></div>";

        div = Dom.create("DIV", {
          props: {
            className:
              "col d-flex align-items-center gap-3 position-relative col-search-item",
          },
          html: t,
        });
        self.popup.popupContainer.appendChild(div);
      });
      if (self.currentData.brands && self.currentData.brands.length) {
        div = Dom.create("HR", {
          props: {
            className: "d-brands",
          },
        });
        self.popup.popupContainer.appendChild(div);
        self.currentData.brands.forEach((item) => {
          let t = "";
          if (item.img) {
            t =
              '<a href="' +
              item.url +
              '" class="link"><div class="search-img" style="background-image: url(\'' +
              item.img +
              "')\"></div></a>";
          } else {
            t = '<div class="search-img"></div>';
          }
          t +=
            '<div class="search-info"><a href="' +
            item.url +
            '" class="link"><div class="search-info-name">' +
            item.name +
            "</div></a></div>";

          div = Dom.create("DIV", {
            props: {
              className:
                "col d-flex align-items-center gap-3 position-relative col-search-item item-brands",
            },
            html: t,
          });
          self.popup.popupContainer.appendChild(div);
        });
      }

      self.popup.setWidth(BX.width(self.container));
      self.popup.show();
    } else {
      BX.cleanNode(self.popup.popupContainer);
      self.popup.close();
    }
  }
  getName() {
    return this.name;
  }
}
